import { addons } from "@storybook/manager-api";

addons.setConfig({ enableShortcuts: false });
